import { createContext } from "react";

interface IAppContext {
    themeType: string,
    language: string,
}

const defaultProps = {
    themeType: 'light',
    language: 'en',
}

export const AppContext = createContext<IAppContext>(defaultProps);